var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSidebarOptionsTrading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.86328 8.35603L9.07757 4.07031H21.9347L25.149 8.35603M5.86328 8.35603V23.356C5.86328 23.9243 6.08905 24.4694 6.49091 24.8713C6.89277 25.2731 7.43782 25.4989 8.00614 25.4989H23.0061C23.5745 25.4989 24.1195 25.2731 24.5214 24.8713C24.9232 24.4694 25.149 23.9243 25.149 23.356V8.35603M5.86328 8.35603H25.149M19.7919 12.6417C19.7919 13.7784 19.3403 14.8685 18.5366 15.6722C17.7329 16.4759 16.6428 16.9275 15.5061 16.9275C14.3695 16.9275 13.2794 16.4759 12.4757 15.6722C11.672 14.8685 11.2204 13.7784 11.2204 12.6417",
    stroke: "white",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarOptionsTrading);
export default __webpack_public_path__ + "static/media/sidebar-options-trading.7df28084e6427f6788e26be05c9a511d.svg";
export { ForwardRef as ReactComponent };